// Written in this round about way for babel-transform-imports
import Router from "react-router/es/Router";

export default Router;


//////////////////
// WEBPACK FOOTER
// /usr/src/site-blog/node_modules/react-router-dom/es/Router.js
// module id = 107
// module chunks = 99